export const getToken = (): string => {
    const token: string = JSON.parse(localStorage.getItem('auth') || '');
    return token;
};